import { RwfBootstrap } from "@common/rwf";
import { IInfOperation } from '@common/utils';
import { CtrlChangeNavUserPassword } from '../rwfuserinteraction/changepassword/changepassword.ctrl';
import { CompatibilityService } from '../services/compatibilityservice';
import { KWFNotificationService } from '../KWFNotificationService';
import { IInfNotification } from '@common/navkendo';
import { NavClientService } from '../../common/navdata/navclientservice';

/** RWF Root Component */
export class RWFRootComponent {
    static TEMPLATE = require('./RWFRoot.component.html');
    static Directive = [() => <ng.IDirective>{
        controller: RWFRootComponent,
        controllerAs: 'vm',
        template: RWFRootComponent.TEMPLATE,
    }];

    static $inject = ["$scope", "CompatibilityService", "RwfBootstrap", "KWFNotificationService"];
  constructor(
        private $scope: ng.IScope,
        private $c: CompatibilityService,
        rwfBootstrap: RwfBootstrap,
        private KWFNotificationService: KWFNotificationService) {
        rwfBootstrap.Resolve.then(s => {
            this.IndicatorStyle = getIdicatorStyle(s.RwfSetup.SystemIndicatorStyle);
            const user = s.RwfSettings.User;
            this.UserHint = user.UserName + (user.IsStandalone ? " (Einfacher Workflowbenutzer)" : "");
        });

        this.ChangePasswordAction = CtrlChangeNavUserPassword.ChangePasswordAction($c);
        this.ChangeUserAction = CtrlChangeNavUserPassword.ChangeUserAction($c);
    }

    public UserHint: string;

    public IndicatorStyle: any;

    public readonly ChangePasswordAction: IInfOperation;

    public readonly ChangeUserAction: IInfOperation;

    public set Notification(value: IInfNotification) {
        this.KWFNotificationService.Notification = value;
    }
    public readonly ClearCacheAction: IInfOperation = {
      Title: "Cache leeren",
      Execute: () => {
        const navClient = new NavClientService(this.$c, this.$c.resolve("NavUrl"), this.$c.resolve("DialogService"));
        this.$scope['IsInRefresh'] = true;
        navClient.ReadMultiple({
          PageName: "FDRW_Workflow_Running_Instances",
          PageCount: 0,
          Constraints: [
            {
              FieldName: "Remark",
              Value: "DeleteUserCache"
            }
          ]
        }).then(result => {
          this.$scope['IsInRefresh'] = false;
          this.$scope.$root.$broadcast('RWF:CacheCleared');
        });
      }
    };
}

function getIdicatorStyle(nSysIndicator: number) {
    if (nSysIndicator > 0) {
      // 'Dark Blue,Light Blue,Dark Green,Light Green,Dark Yellow,Light Yellow,Red,Orange,Deep Purple,Bright Purple'
        var bgcolor = ["", "#75d8ff", "#008489"/** our default */, "#59ccb4", "#787122 ", "#d9d47a", "#eb0601", "#e89e63", "#915cb0", "#dbbdeb"][nSysIndicator];
        var fgcolor = (nSysIndicator === 7 || nSysIndicator === 9) ? "#000000" : "#ffffff";
    }

    return (bgcolor && { "background-color": bgcolor, "color": fgcolor, "padding": "0 3px 1px 2px", "margin-left": "2px", "border": "1px solid white" }) || undefined;
}
